const SET_SCROLL = 'SET_SCROLL'

export {
    SET_SCROLL
}